<template>
    <div @click.stop="onClick"
         :class="{ 'container fixed top-0 left-0 pt-9 pb-4 w-full text-lg bg-white overflow-y-auto h-full z-30': open }"
         class="transition-colors lg:static lg:bg-transparent lg:pointer-events-none lg:p-0 lg:h-auto lg:p-auto lg:text-sm">
        <icon name="back" v-if="open" class="p-4 w-14 h-14 lg:hidden" @click.native.stop="open = false" />
        <div class="lg:pointer-events-auto"
             :class="[open ? 'opacity-30 font-heading font-bold text-2xl text-gray lg:font-sans lg:font-normal lg:text-sm': 'opacity-80 lg:opacity-100 pointer-events-none']">
            <slot />
        </div>
        <slot name="items" :open="open" />
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Icon from '../base/Icon.vue';

@Component({
    components: { Icon }
})
export default class FooterNavItem extends Vue {
    @Prop({ required: true }) link: string;

    open = false;

    onClick(event: MouseEvent) {
        if (!this.open) {
            event.stopPropagation();
            this.open = true;
        }
    }

    @Watch('open')
    openChanged() {
        document.body.classList.toggle('overflow-hidden', this.open);
    }
}
</script>
